module.exports = __webpack_public_path__ + "img/rich.e55d005f.jpg";